<script lang="ts" setup>
withDefaults(
  defineProps<{
    content?: string
    isDisabled?: boolean
    contentClass?: string
  }>(),
  {
    content: '',
    contentClass: ''
  }
)
</script>

<template>
  <UTooltip :text="content" :disabled="isDisabled" :content="{ side: 'top' }">
    <span
      :class="[
        contentClass,
        {
          'border-dashed border-b cursor-pointer border-white inline-flex':
            !isDisabled
        }
      ]"
    >
      <slot />
    </span>

    <template v-if="$slots.tooltip" #content>
      <slot name="tooltip" />
    </template>
  </UTooltip>
</template>
